(function ($) {
        
    function submitForm(form, clickedBtn) {
        
        // create loading
        clickedBtn.attr('disabled', true).addClass('loading');       

        var params = form.serialize();
        
        $.ajax({													
            method: 'POST',
            url: cyclone3.domain + '/json/' + form.data('service'),
            data: params									
        }).done(function(e) {
            // remove loading
            clickedBtn.attr('disabled', false).removeClass('loading');	
            form.find('.form-group').removeClass('is-invalid');
            form.find('.alert-danger').addClass('d-none');		

            if (e.success == false) {                
                $.each(e.invalid, function( index, errorName ) {
                    form.find('[name="' + errorName + '"]').closest('.form-group').addClass('is-invalid'); 
                });
                
                $.each(e.invalid_custom, function( index, errorName ) {
                    form.find('.error-'+errorName).removeClass('d-none').show();
                    return false;
                });                
            } else if (e.success == true) {
                if (e.redirect_url){
                    window.location.replace(e.redirect_url);
                } else {                                                    
                    form.find('.form-body').hide();                  
                    form.find('.form-success').removeClass('d-none').show();
                }
            } 
        });
    }
    
    // ALL FORMS
    if ($('form [type="submit"]')){
        $(document).on("submit", 'form', function(e) {        
            e.preventDefault();
            submitForm($(this), $(this).find('[type="submit"]'));
        });
    };
    
})(jQuery);